module.exports = __webpack_public_path__ + "media/src/images/logo-dbc54519d6a8fd084a343d3b78b2cad0.svg";